import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=87cb8132&scoped=true"
import script from "./AddAccount.vue?vue&type=script&lang=js"
export * from "./AddAccount.vue?vue&type=script&lang=js"
import style0 from "./AddAccount.vue?vue&type=style&index=0&id=87cb8132&prod&lang=css"
import style1 from "./AddAccount.vue?vue&type=style&index=1&id=87cb8132&prod&scoped=true&lang=css"
import style2 from "./AddAccount.vue?vue&type=style&index=2&id=87cb8132&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cb8132",
  null
  
)

export default component.exports